import { INSTAGRAM } from '@/lib/socialProfile';

import { MentionsInstagram, requestInstagramParams } from './instagram';

export const MentionsConfig = (type) => {
    let config;
    let fields;
    let parameters;
    switch (type) {
        case INSTAGRAM:
            config = MentionsInstagram;
            fields = requestInstagramParams;
            break;
    }
    return { config, fields, parameters };
};
